import React from "react";
import "./Healthcare.css";

const Healthcare = () => {
  const healthcareProducts = [
    {
      id: 1,
      name: "Hospital Management System (HMS)",
      description: "Comprehensive healthcare management solution covering all aspects of hospital administration and patient care.",
      features: [
        "Electronic Health Records (EHR)",
        "Appointment scheduling",
        "Billing and insurance processing",
        "Pharmacy management",
        "Laboratory integration",
        "Inventory management"
      ],
      expectations: [
        "40% reduction in administrative workload",
        "Improved patient satisfaction scores",
        "Real-time bed availability tracking",
        "HIPAA compliant data security"
      ],
      customization: [
        "Specialty-specific modules (Cardiology, Oncology, etc.)",
        "Multi-branch hospital support",
        "Custom reporting templates",
        "Telemedicine integration"
      ]
    },
    {
      id: 2,
      name: "Clinic Management System (CMS)",
      description: "Efficient practice management solution tailored for small to medium healthcare clinics.",
      features: [
        "Patient registration and records",
        "Appointment management",
        "Prescription management",
        "Billing and invoicing",
        "Staff scheduling",
        "Basic analytics"
      ],
      expectations: [
        "50% faster patient check-in process",
        "Reduced no-show rates with automated reminders",
        "Paperless clinic operations",
        "Mobile access for practitioners"
      ],
      customization: [
        "Specialty-specific templates",
        "Custom form builder",
        "Integration with diagnostic labs",
        "Multi-location support"
      ]
    },
    {
      id: 3,
      name: "Online Appointment Booking",
      description: "Digital solution for scheduling and managing healthcare appointments.",
      features: [
        "Online booking portal",
        "Calendar management",
        "Automated reminders",
        "Resource scheduling",
        "Patient notifications",
        "Reporting"
      ],
      expectations: [
        "Reduced no-shows by 30%",
        "24/7 booking availability",
        "Improved patient satisfaction",
        "Staff efficiency"
      ],
      customization: [
        "Branded booking pages",
        "Custom booking rules",
        "Insurance verification",
        "API access"
      ]
    },
    {
      id: 4,
      name: "Pharmacy Management System",
      description: "Complete solution for pharmacy operations and medication management.",
      features: [
        "Inventory management",
        "Prescription processing",
        "Patient records",
        "Billing and insurance",
        "Expiry tracking",
        "Reporting"
      ],
      expectations: [
        "Accurate medication dispensing",
        "Reduced inventory costs",
        "Regulatory compliance",
        "Improved customer service"
      ],
      customization: [
        "Multi-location support",
        "Mobile app for patients",
        "Loyalty programs",
        "Supplier integration"
      ]
    },
    {
      id: 5,
      name: "Fitness CRM / Gym Management",
      description: "Complete management solution for fitness centers and health clubs.",
      features: [
        "Member management",
        "Class scheduling",
        "Attendance tracking",
        "Payment processing",
        "Workout planning",
        "Reporting"
      ],
      expectations: [
        "Improved member retention",
        "Streamlined operations",
        "Better staff productivity",
        "Increased revenue"
      ],
      customization: [
        "Branded member app",
        "Wearable integration",
        "Custom membership plans",
        "Access control"
      ]
    },
    {
      id: 6,
      name: "Telemedicine & Doctor Consultation Portal",
      description: "Secure platform for remote healthcare consultations and virtual care.",
      features: [
        "Video consultations",
        "Secure messaging",
        "E-prescriptions",
        "Patient records access",
        "Payment processing",
        "Reporting"
      ],
      expectations: [
        "Expanded patient reach",
        "Reduced no-shows",
        "HIPAA compliant",
        "Improved care access"
      ],
      customization: [
        "Branded portals",
        "Integration with EHR",
        "Multi-language support",
        "Custom workflows"
      ]
    }
  ];

  return (
    <div className="healthcare-container">
      <div className="healthcare-header">
        <h1>Healthcare & Wellness Solutions</h1>
        <p className="subtitle">Transform healthcare delivery with our specialized digital health solutions</p>
      </div>

      <div className="healthcare-grid">
        {healthcareProducts.map((product) => (
          <div key={product.id} className="healthcare-card">
            <div className="healthcare-card-header">
              <h2>{product.name}</h2>
              <p className="healthcare-card-description">{product.description}</p>
            </div>

            <div className="healthcare-card-details">
              <div className="healthcare-card-section">
                <h3>Key Features</h3>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>

              <div className="healthcare-card-section">
                <h3>What you can Expect</h3>
                <ul>
                  {product.expectations.map((expectation, index) => (
                    <li key={index}>{expectation}</li>
                  ))}
                </ul>
              </div>

              <div className="healthcare-card-section">
                <h3>Customization Options</h3>
                <ul>
                  {product.customization.map((option, index) => (
                    <li key={index}>{option}</li>
                  ))}
                </ul>
              </div>
            </div>

            {/* <div className="healthcare-card-footer">
              <button className="healthcare-demo-button">Request Demo</button>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Healthcare;